/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse any text — flip it character by character, reverse the order of words, or reverse the order of lines.`)
};

const es_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invierte cualquier texto — voltéalo carácter por carácter, revierte el orden de palabras o invierte el orden de líneas.`)
};

const de_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehre jeden Text um — drehe ihn Zeichen für Zeichen um, kehre die Reihenfolge der Wörter um oder kehre die Reihenfolge der Zeilen um.`)
};

const nl_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draai elke tekst om — keer het teken voor teken om, draai de woordvolgorde om, of draai de lijnvolgorde om.`)
};

const fr_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversez n'importe quel texte — retournez-le caractère par caractère, inversez l'ordre des mots ou inversez l'ordre des lignes.`)
};

const it_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverti qualsiasi testo — capovolgilo carattere per carattere, inverti l'ordine delle parole o inverti l'ordine delle righe.`)
};

const pt_br2_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverta qualquer texto — vire-o caractere por caractere, inverta a ordem das palavras ou inverta a ordem das linhas.`)
};

const pt_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverta qualquer texto — inverta-o caractere por caractere, inverta a ordem das palavras ou inverta a ordem das linhas.`)
};

const ja_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のテキストを反転させます。文字ごとに反転させたり、単語の順序を逆にしたり、行の順序を逆にしたりできます。`)
};

const zh_rv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反转任意文本——逐字符翻转、反转单词顺序，或反转行顺序。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_intro", locale)
	if (locale === "en") return en_rv_intro(inputs)
	if (locale === "es") return es_rv_intro(inputs)
	if (locale === "de") return de_rv_intro(inputs)
	if (locale === "nl") return nl_rv_intro(inputs)
	if (locale === "fr") return fr_rv_intro(inputs)
	if (locale === "it") return it_rv_intro(inputs)
	if (locale === "pt-BR") return pt_br2_rv_intro(inputs)
	if (locale === "pt") return pt_rv_intro(inputs)
	if (locale === "ja") return ja_rv_intro(inputs)
	return zh_rv_intro(inputs)
};